import { SwapHoriz, TrendingDown } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import AICoachButton from '../dashboard/AICoachButton';

interface TrainingActionsProps {
  isSwapMode: boolean;
  isDeloadWeek: boolean;
  isMobile?: boolean;
  onSwapModeToggle: () => void;
  onDeloadWeekClick: () => void;
  onAICoachChangesApplied?: () => void;
}

export const TrainingActions: React.FC<TrainingActionsProps> = ({
  isSwapMode,
  isDeloadWeek,
  isMobile = false,
  onSwapModeToggle,
  onDeloadWeekClick,
  onAICoachChangesApplied,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* AI Coach Button */}
      <AICoachButton
        onChangesApplied={onAICoachChangesApplied || (() => {})}
        disabled={isSwapMode}
        fullWidth
      />

      <Button
        variant={isSwapMode ? 'contained' : 'outlined'}
        size="medium"
        fullWidth
        startIcon={<SwapHoriz />}
        onClick={onSwapModeToggle}
        sx={{
          textTransform: 'none',
          ...(isSwapMode
            ? {
                background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                border: 0,
                boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
                color: 'white',
                '&:hover': {
                  background: 'linear-gradient(45deg, #FE6B8B 60%, #FF8E53 100%)',
                  boxShadow: '0 4px 8px 3px rgba(255, 105, 135, .4)',
                  transform: 'translateY(-1px)',
                },
              }
            : {
                borderColor: '#9C27B0',
                color: '#9C27B0',
                background: 'linear-gradient(45deg, transparent 0%, rgba(156, 39, 176, 0.05) 100%)',
                '&:hover': {
                  borderColor: '#7B1FA2',
                  background:
                    'linear-gradient(45deg, rgba(156, 39, 176, 0.1) 0%, rgba(156, 39, 176, 0.15) 100%)',
                  transform: 'translateY(-1px)',
                },
              }),
          transition: 'all 0.3s ease',
        }}
      >
        {isMobile ? '' : isSwapMode ? '❌ Cancel Swap' : 'Swap Workouts'}
      </Button>

      <Button
        variant="outlined"
        size="medium"
        fullWidth
        startIcon={<TrendingDown />}
        onClick={onDeloadWeekClick}
        disabled={!isDeloadWeek}
        sx={{
          textTransform: 'none',
          borderColor: isDeloadWeek ? '#FF9800' : '#CCCCCC',
          color: isDeloadWeek ? '#FF9800' : '#999999',
          background: isDeloadWeek
            ? 'linear-gradient(45deg, transparent 0%, rgba(255, 152, 0, 0.05) 100%)'
            : 'transparent',
          '&:hover': {
            borderColor: isDeloadWeek ? '#F57C00' : '#CCCCCC',
            background: isDeloadWeek
              ? 'linear-gradient(45deg, rgba(255, 152, 0, 0.1) 0%, rgba(255, 152, 0, 0.15) 100%)'
              : 'transparent',
            transform: isDeloadWeek ? 'translateY(-1px)' : 'none',
          },
          '&:disabled': {
            borderColor: '#CCCCCC',
            color: '#999999',
            background: 'transparent',
          },
          transition: 'all 0.3s ease',
        }}
      >
        {isMobile ? '' : 'Change Deload Week'}
      </Button>
    </Box>
  );
};
